import { render } from "./Modulos.vue?vue&type=template&id=5cf08436"
import script from "./Modulos.vue?vue&type=script&lang=js"
export * from "./Modulos.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__